// src/components/Banner.js
import React from "react";

function Pagetitlesection({ title, backgroundImage }) {
  return (
    <div className="relative isolate overflow-hidden bg-gray-900 py-4 sm:py-14">
      {backgroundImage && (
        <img
          src={backgroundImage}
          alt={`${title} Banner`}
          className="absolute inset-0 -z-10 w-full h-full object-cover object-center"
        />
      )}
      <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
        <h1 className="text-lg md:text-3xl font-medium tracking-tight text-white">
          {title}
        </h1>
      </div>
    </div>
  );
}

export default Pagetitlesection;
